export default __webpack_public_path__ + "static/media/givepower_TM_logo_Horizontal_White.0753aa91.svg";